import React from 'react';
import Text from '../../../ui/Text';
import { detectMobile } from '../../../utils/UiHelper';

const WelcomeText = () => {
    return (
        <>
            <Text
                size={detectMobile() ? 'x2' : '26'}
                color={'#333'}
                bold
                margin={'0'}
                padding={'0'}
                lh={detectMobile() ? '18' : '30'}
            >
                Velkommen til SpilKlub25
            </Text>
            <Text
                color={'#333'}
                margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                lh={'22'}
                padding={'0'}
            >
                Med SpilKlub25 spiller du som et hold, hvor du køber andele til
                en fælles kupon sammen med dine holdkammerater.
            </Text>
        </>
    );
};

export default WelcomeText;
